import { Box, Typography } from "@mui/material";
import React from "react";
import {
  blueColor04,
  greyColor37,
  greyColor40,
  whiteColor,
} from "../../../configs/styles/muiThemes";

const SyncStepper = ({ currentPage }) => {
  const SYNC_STEPPER = [
    { id: 1, label: "Provide SKU Ids", pageName: "provide-sku" },
    { id: 2, label: "Sync SKUs", pageName: "sync-sku" },
    { id: 3, label: "Assign Category", pageName: "assign-category" },
    { id: 4, label: "Product Attributes", pageName: "product-info" },
    { id: 5, label: "ONDC Parameters", pageName: "ondc" },
    {
      id: 6,
      label: "ONDC Specs",
      pageName: "ondcSpecGroup",
      pageTwoName: "addOndcSpecs",
    },
    { id: 7, label: "SKU Sync Done", pageName: "done" },
  ];

  const getCurrentStep = (page) => {
    switch (page) {
      case "provide-sku":
        return 0;
      case "sync-sku":
        return 1;
      case "assign-category":
        return 2;
      case "product-info":
        return 3;
      case "ondc":
        return 4;
      case "ondcSpecGroup":
        return 5;
      case "addOndcSpecs":
        return 5;
      case "done":
        return 6;

      default:
        return 0;
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={3}>
      {SYNC_STEPPER.map((item, index) => (
        <Box
          sx={{
            width: "130px",
            display: "flex",
            alignItems: "center",
            gap: 2,
            position: "relative",
          }}
        >
          <Box
            width="114px"
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={1}
            sx={{ cursor: "pointer" }}
            // onClick={() => handleStepperClick(item, index)}
          >
            <Box sx={styles.countCircle(getCurrentStep(currentPage) >= index)}>
              {item.id}
            </Box>

            <Typography
              variant="body1"
              fontSize={12.5}
              fontWeight={400}
              color={greyColor37}
            >
              {item.label}
            </Typography>
          </Box>

          {SYNC_STEPPER.length !== index + 1 && (
            <Box
              sx={{
                width: "67px",
                height: "1.5px",
                backgroundColor: greyColor37,
                mt: -3,
                position: "absolute",
                left: "100px",
              }}
            />
          )}
        </Box>
      ))}
    </Box>

    // <Box display="flex" alignItems="center" gap={3}>
    //   {SYNC_STEPPER.map((item, index) => (
    //     <Box
    //       sx={{
    //         width: index == 0 ? "190px" : "170px",
    //         display: "flex",
    //         alignItems: "center",
    //         gap: 2,
    //         position: "relative",
    //       }}
    //     >
    //       <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
    //         <Box sx={styles.countCircle(getCurrentStep(currentPage) >= index)}>
    //           {item.id}
    //         </Box>

    //         <Typography
    //           variant="body1"
    //           fontSize={12.5}
    //           fontWeight={getCurrentStep(currentPage) >= index ? 600 : 400}
    //           color={
    //             getCurrentStep(currentPage) >= index ? blueColor04 : greyColor37
    //           }
    //         >
    //           {item.label}
    //         </Typography>
    //       </Box>

    //       {SYNC_STEPPER.length !== index + 1 && (
    //         <Box
    //           sx={{
    //             width: "50px",
    //             height: "1.5px",
    //             backgroundColor:
    //               getCurrentStep(currentPage) > index
    //                 ? blueColor04
    //                 : greyColor37,
    //             mt: 0,
    //             position: "absolute",
    //             left: index == 0 ? "140px" : "120px",
    //           }}
    //         />
    //       )}
    //     </Box>
    //   ))}
    // </Box>
  );
};

export default SyncStepper;

const styles = {
  countCircle: (isActive) => ({
    width: "25px",
    height: "25px",
    borderRadius: "40px",
    backgroundColor: isActive ? blueColor04 : whiteColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 500,
    color: isActive ? whiteColor : greyColor40,
    border: isActive ? `1px solid ${blueColor04}` : `1px solid ${greyColor40}`,
  }),
};
